export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 8.8615cba3.png";